import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { trpc } from "../dashboard/utils/trpc";
import { httpBatchLink } from "@trpc/client";
import { useState } from "react";

export function WithNonAuthedTrpcClient(props: { children: React.ReactNode }) {
	const [queryClient] = useState(() => new QueryClient());
	const [trpcClient] = useState(() =>
		trpc.createClient({
			links: [
				httpBatchLink({
					url: "/trpc",
				}),
			],
		})
	);

	return (
		<trpc.Provider client={trpcClient} queryClient={queryClient}>
			<QueryClientProvider client={queryClient}>
				{props.children}
			</QueryClientProvider>
		</trpc.Provider>
	);
}
